<div>
    <mat-toolbar color="primary">
        <mat-toolbar-row fxLayout="row" color="primary" fxLayoutAlign="space-between center">
            <a class="pt-1-rem ph-1-rem brand">
                <img src="./assets/green-logo.png" alt="App logo" />
            </a>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
